import { EMAIL } from '@belong/common';
import { RefreshMiamiBanner } from 'src/components/refresh-miami-banner/refresh-miami-banner';
import { SfistBayAreaBanner } from 'src/components/sfist-bay-area-banner/sfist-bay-area-banner';
import { SanDiegoShortTermRentalsBanner } from '../homeowners/componentes/san-diego-short-term-rentals-banner/san-diego-short-term-rentals-banner';
// The three maps annotated `Record<string, …>` here are all looked up with a
// value built from data — a city slug, a region name, a school level code —
// rather than with one of their own keys, and every caller handles a miss.
export const SLUG_TO_CANONICAL_MAP: Record<string, string> = {
  'miami-fl': 'https://belonghome.com/homeowners/miami',
  'seattle-wa': 'https://belonghome.com/homeowners/seattle',
};

export const REGION_ARTICLES_MAP: Record<string, () => JSX.Element> = {
  BayArea: SfistBayAreaBanner,
  Miami: RefreshMiamiBanner,
  SanDiego: SanDiegoShortTermRentalsBanner,
};

const EXPERTISE_HREF_MAP: Record<string, string> = {
  BayArea:
    'https://www.expertise.com/ca/san-francisco/property-management#belong',
  LosAngeles:
    'https://www.expertise.com/ca/los-angeles/property-management#belong',
  SanDiego: 'https://www.expertise.com/ca/san-diego/property-management#belong',
  Seattle: 'https://www.expertise.com/wa/seattle/property-management#belong',
  Miami: 'https://www.expertise.com/fl/miami/property-management#belong',
};

const CRUNCHBASE_HREF = () =>
  'https://www.crunchbase.com/organization/belong-336d';
const BUSINESS_INSIDER_HREF = () =>
  'https://www.businessinsider.com/most-promising-consumer-tech-startups-of-2022-8#belong-a-home-rental-management-platform-3';
const CBINSIGHTS_HREF = () =>
  'https://www.cbinsights.com/research/report/top-fintech-startups-2022/';
const TECHCRUNCH_HREF = () =>
  'https://techcrunch.com/2022/05/19/belong-secures-80m-in-equity-debt-to-take-the-pain-out-of-rental-property-management';
const MSN_HREF = () =>
  'https://www.msn.com/en-us/money/realestate/10-us-markets-where-seasoned-investors-are-buying-the-most-real-estate/ss-AA158573';
const EXPERTISE_HREF = (region: string) => EXPERTISE_HREF_MAP[region];

type SocialProofLogo = {
  src: string;
  /** Only the Expertise link varies by region; the rest ignore the argument. */
  href: (region: string) => string | undefined;
};

export const LIGHT_SOCIAL_PROOF_LOGOS: SocialProofLogo[] = [
  {
    src: '/logos/crunchbase-logo.svg',
    href: CRUNCHBASE_HREF,
  },
  {
    src: '/logos/business-insider-logo.svg',
    href: BUSINESS_INSIDER_HREF,
  },
  {
    src: '/logos/cbinsights-logo.svg',
    href: CBINSIGHTS_HREF,
  },
  {
    src: '/logos/techcrunch-logo.svg',
    href: TECHCRUNCH_HREF,
  },
  {
    src: '/logos/msn-logo.svg',
    href: MSN_HREF,
  },
  {
    src: '/logos/expertise-logo.svg',
    href: EXPERTISE_HREF,
  },
];

// TODO: Mark for deletion!

type GoogleMyBusinessProfileEntry = {
  addressFirstLine: string;
  addressSecondLine: string;
  mapUrl: string;
  cidLink: string;
  reviewsLink?: string;
  phoneNumber: string;
  email: string;
  state: string;
  city: string;
  region: number;
};

const SOUTH_SAN_FRANCISCO_GOOGLE_MY_BUSINESS_PROFILE = {
  addressFirstLine: '233 E Harris Ave Unit F3',
  addressSecondLine: 'South San Francisco, CA 94080',
  mapUrl:
    'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d12635.672785984982!2d-122.3984101!3d37.6511272!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xcf048816a13045b!2sBelong!5e0!3m2!1sen!2smx!4v1669243619626!5m2!1sen!2smx',
  cidLink: 'https://www.google.com/maps?cid=932324843533304923',
  phoneNumber: '(650) 885-9166',
  email: EMAIL,
  state: 'CA',
  city: 'San Francisco',
  region: 1,
};

export const GMB_LINKS: Record<string, GoogleMyBusinessProfileEntry> = {
  'san-mateo-ca': {
    addressFirstLine: '100 S Ellsworth Ave',
    addressSecondLine: 'San Mateo, CA 94401',
    mapUrl:
      'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d12650.049488317567!2d-122.3250044!3d37.5665509!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xc47f158c99d47eb7!2sBelong!5e0!3m2!1sen!2smx!4v1669241263128!5m2!1sen!2smx',
    cidLink: 'https://www.google.com/maps?cid=14159059447096573623',
    reviewsLink:
      'https://search.google.com/local/reviews?placeid=ChIJqYjUB-u7j4ARt37UmYwVf8Q&q=%D0%9F%D0%98%D0%A6%D0%98%D0%9A%D0%90%D0%A2%D0%9E&hl=en',
    phoneNumber: '(650) 885-9166',
    email: EMAIL,
    state: 'CA',
    city: 'San Mateo',
    region: 1,
  },
  'escondido-ca': {
    addressFirstLine: '500 La Terraza Blvd',
    addressSecondLine: 'Escondido, CA 92025',
    mapUrl:
      'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d13367.477136383324!2d-117.0958645!3d33.1125202!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x7c97846fc0f7c95b!2sBelong!5e0!3m2!1sen!2smx!4v1669242143812!5m2!1sen!2smx',
    cidLink: 'https://www.google.com/maps?cid=8977789997700073819',
    reviewsLink:
      'https://search.google.com/local/reviews?placeid=ChIJTZXYBsP124ARW8n3wG-El3w&q=Belong&hl=en',
    phoneNumber: '(858) 244-9339',
    email: EMAIL,
    state: 'CA',
    city: 'Escondido',
    region: 4,
  },
  'miami-fl': {
    addressFirstLine: '218 NW 24th St',
    addressSecondLine: 'Miami, FL 33127',
    mapUrl:
      'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14368.431046153928!2d-80.1995495!3d25.8000187!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xec8150022565a750!2sBelong!5e0!3m2!1sen!2smx!4v1669242624687!5m2!1sen!2smx',
    cidLink: 'https://www.google.com/maps?cid=17041990435094243152',
    reviewsLink:
      'https://search.google.com/local/reviews?placeid=ChIJKYaW0fG32YgRUKdlJQJQgew&q=Belong&hl=en',
    phoneNumber: '(786) 628-0600',
    email: EMAIL,
    state: 'FL',
    city: 'Miami',
    region: 6,
  },
  'south-san-francisco-ca': {
    ...SOUTH_SAN_FRANCISCO_GOOGLE_MY_BUSINESS_PROFILE,
  },
  'san-francisco-ca': {
    ...SOUTH_SAN_FRANCISCO_GOOGLE_MY_BUSINESS_PROFILE,
  },
  'sacrament-ca': {
    addressFirstLine: '5728 Garfield Ave #9',
    addressSecondLine: 'Sacramento, CA 95841',
    mapUrl:
      'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d12460.33750232088!2d-121.3358948!3d38.6699289!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x809adfa44eb7378d%3A0x1201a87999a33989!2sBelong!5e0!3m2!1sen!2sar!4v1682448811805!5m2!1sen!2sar',
    cidLink: 'https://www.google.com/maps?cid=1297503407881533833',
    reviewsLink:
      'https://search.google.com/local/reviews?placeid=ChIJjTe3TqTfmoARiTmjmXmoARI',
    phoneNumber: '(916) 823-8313',
    email: EMAIL,
    state: 'CA',
    city: 'Sacramento',
    region: 8,
  },
  'los-angeles-ca': {
    addressFirstLine: '400 PMB1182, 453 S Spring St',
    addressSecondLine: 'Los Angeles, CA 90013',
    mapUrl:
      'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d13223.389342100556!2d-118.2495256!3d34.047787!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80c2c7b55fbc2d97%3A0x6ea463faff496c30!2sBelong!5e0!3m2!1sen!2sar!4v1682450568496!5m2!1sen!2sar',
    cidLink: 'https://www.google.com/maps?cid=7972607170028596272',
    reviewsLink:
      'https://www.google.com/search?hl=en-AR&gl=ar&q=Belong,+400+PMB1182,+453+S+Spring+St,+Los+Angeles,+CA+90013,+United+States&ludocid=7972607170028596272&lsig=AB86z5WhOhS7tLE4XkETBRh9RHLc#lrd=0x80c2c7b55fbc2d97:0x6ea463faff496c30,3',
    phoneNumber: '(213) 444-2114',
    email: EMAIL,
    state: 'CA',
    city: 'Los Angeles',
    region: 2,
  },
  'seattle-wa': {
    addressFirstLine: '720 Seneca St ste 107 #1082',
    addressSecondLine: 'Seattle, WA 98101',
    mapUrl:
      'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d10759.42624977629!2d-122.3301694!3d47.6094787!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x54906b139ed45b51%3A0x179baa76da8f8839!2sBelong!5e0!3m2!1sen!2sar!4v1682451194529!5m2!1sen!2sar',
    cidLink: 'https://www.google.com/maps?cid=1701140711712196665',
    reviewsLink:
      'https://search.google.com/local/reviews?placeid=ChIJUVvUnhNrkFQROYiP2naqmxc',
    phoneNumber: '(206) 202-7090',
    email: EMAIL,
    state: 'WA',
    city: 'Seattle',
    region: 5,
  },
  'oakland-ca': {
    addressFirstLine: '1423 Broadway #1004',
    addressSecondLine: 'Oakland, CA 94612',
    mapUrl:
      'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d12609.484339165043!2d-122.2710631!3d37.8047762!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808f81e25aaabda3%3A0x1ea26169ee4927ad!2sBelong!5e0!3m2!1sen!2sar!4v1682452516524!5m2!1sen!2sar',
    cidLink: 'https://www.google.com/maps?cid=2207433874962196397',
    reviewsLink:
      'https://search.google.com/local/reviews?placeid=ChIJo72qWuKBj4ARrSdJ7mlhoh4',
    phoneNumber: '(510) 901-3434',
    email: EMAIL,
    state: 'CA',
    city: 'Oakland',
    region: 1,
  },
  'manhattan-beach-ca': {
    addressFirstLine: '1240 Rosecrans Ave',
    addressSecondLine: 'Manhattan Beach, CA 90266',
    mapUrl:
      'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d26492.488602038105!2d-118.40273928221009!3d33.900956399999984!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80c2b504a8828d69%3A0x5b90d1e1e47e54a3!2sBelong!5e0!3m2!1sen!2sar!4v1682452907916!5m2!1sen!2sar',
    cidLink: 'https://www.google.com/maps?cid=6598004222229107875',
    reviewsLink:
      'https://search.google.com/local/reviews?placeid=ChIJaY2CqAS1woARo1R-5OHRkFs',
    phoneNumber: '(310) 441-8075',
    email: EMAIL,
    state: 'CA',
    city: 'Manhattan Beach',
    region: 2,
  },
  'tampa-fl': {
    addressFirstLine: '6421 N Florida Ave D-1595',
    addressSecondLine: 'Tampa, FL 33604',
    mapUrl:
      'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2907.9025009626635!2d2!3d3!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x143b459b3e3aae96!2z0J_QmNCm0JjQmtCQ0KLQng!5e0!3m2!1sbg!2sus!4v1448115192914',
    cidLink: 'https://www.google.com/maps?cid=1457835437450768022',
    reviewsLink:
      'https://search.google.com/local/reviews?placeid=ChIJGUyvUF_HwogRlq46PptFOxQ',
    phoneNumber: '(813) 796-6090',
    email: EMAIL,
    state: 'FL',
    city: 'Tampa',
    region: 10,
  },
};

export const SCHOOL_LEVEL_MAP: Record<string, string> = {
  p: 'Pre-K',
  e: 'Elementary',
  m: 'Middle',
  h: 'High',
};
